document.addEventListener("DOMContentLoaded", () => {
    const tabTitles = document.querySelectorAll(".tab-title-container");
    const tabContents = document.querySelectorAll(".tab-text-area");
    const tabsContainer = document.querySelector(".tabs");

    const isMobile = () => window.innerWidth < 768;

    // Rearranges markup for tabs to allow for an accordion at mobile viewports:
    const rearrangeForAccordion = () => {
        const tabsList = tabsContainer.querySelector(".tabs-list");

        if (isMobile()) {
            tabTitles.forEach((tab, index) => {
                const content = tabContents[index];
                if (content && !tab.nextElementSibling?.classList.contains("tab-text-area")) {
                    tab.after(content);
                }
            });
        } else {
            tabTitles.forEach((tab) => {
                if (!tabsList.contains(tab)) {
                    tabsList.append(tab);
                }
            });
            tabContents.forEach((content) => {
                if (tabsList.contains(content)) {
                    tabsContainer.append(content);
                }
            });
        }
    };

    const handleTabClick = (tab) => {
        const target = tab.getAttribute("data-tab");
        const content = document.getElementById(target);

        if (isMobile()) {
            const isActive = tab.classList.contains("active");

            tabTitles.forEach((title) => title.classList.remove("active"));
            tabContents.forEach((content) => {
                content.classList.remove("active");
            });

            if (!isActive) {
                tab.classList.add("active");
                content.classList.add("active");
            }
        } else {
            tabTitles.forEach((title) => title.classList.remove("active"));
            tabContents.forEach((content) => {
                content.classList.remove("active");
            });

            tab.classList.add("active");
            content.classList.add("active");
        }
    };

    tabTitles.forEach((tab) => {
        tab.addEventListener("click", function () {
            handleTabClick(this);
        });
    });

    rearrangeForAccordion();

    let resizeTimeout;

    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            rearrangeForAccordion();
        }, 100);
    });
});
